import { axiosInstance } from './Api';

export const getWooCommerceConnection = async (sessionId, platform = 'woocommerce') => {
    const { data } = await axiosInstance.get(`/integrations/${platform}/onboarding/${sessionId}`);
    return data;
};

export const authorizeWooCommerceConnection = async (sessionId, payload, platform = 'woocommerce') => {
    const { data } = await axiosInstance.post(`/integrations/${platform}/onboarding/${sessionId}/authorize`, payload);
    return data;
};
